var map = {
	"./": 7,
	"./common": 54,
	"./common.js": 54,
	"./development": 86,
	"./development.js": 86,
	"./index": 7,
	"./index.js": 7,
	"./production": 87,
	"./production.js": 87,
	"./staging": 88,
	"./staging.js": 88,
	"./test": 89,
	"./test.js": 89
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 163;